import * as React from 'react';
import { FeedListItem } from './FeedListItem';
import Section from './Section';
import { Feed } from '../feed';

const activeFeeds = (feeds: Feed[]) => {
  return feeds.filter((feed: Feed) => feed.active);
};

const inactiveFeeds = (feeds: Feed[]) => {
  return feeds.filter((feed: Feed) => !feed.active);
};

const mapToFeedItem = (feed: Feed, index: number) => (
  <FeedListItem feed={feed} key={index} />
);

type Props = {
  feeds: Feed[];
};

export default function FeedsList(props: Props) {
  return (
    <React.Fragment>
      <Section title="Active">
        {activeFeeds(props.feeds).map(mapToFeedItem)}
      </Section>
      {inactiveFeeds(props.feeds).length > 0 && (
        <Section title="Previous">
          {inactiveFeeds(props.feeds).map(mapToFeedItem)}
        </Section>
      )}
    </React.Fragment>
  );
}
